import React from "react";
import { Box } from "@mui/material";
import { translate } from "../../../../services";
import $ from "jquery";
import { useSelector } from "react-redux";

const SelectFilterMessageComponent = ({ message, heading, icon, height, forMobile, forDesktop }) => {

  const screenSize = useSelector((state)=>state.screenSize)
  let totalHeight = height+"px";
  return (
    <div className="accessory-selection-type-1-main-container" style={{height:screenSize.width>900&&totalHeight, overflow:"hidden"}}>
      <div className="inncer-container">
        <div className="empty-icon">
          <Box component="img" src={icon}></Box>
        </div>
        <div className="message">
          <span className={forMobile&&forDesktop?screenSize.width>900?forDesktop.heading?"heading" : "hide-heading":forMobile.heading?"heading" : "hide-heading": heading ? "heading" : "hide-heading"}>
            {translate(forMobile&&forDesktop?screenSize.width>900?forDesktop.heading:forMobile.heading:heading)}
          </span>
          <span>{translate(forMobile&&forDesktop?screenSize.width>900?forDesktop.message:forMobile.message:message)}</span>
        </div>
      </div>
    </div>
  );
};
const SelectFilterMessage = (props) => {
  return SelectFilterMessageComponent(props);
};

export default SelectFilterMessage;
